import { IObservedSelectOption } from '../interfaces/IObservedSelectOption';

export const observedSelectOptions: IObservedSelectOption[] = [
  {
    id: 0,
    label: 'Соблюдено',
    value: true,
  },
  {
    id: 1,
    label: 'Не соблюдено',
    value: false,
  },
];
